import React from 'react';
import { compose } from 'redux';
import { getTitles } from 'Helpers/item';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import css from './NavBar.scss';
import classNames from 'classnames';
import FavoriteButton from '../../components/FavoriteButton/FavoriteButton';
import ShareButton from '../../components/ShareButton/ShareButton';
import withConfig from 'HOCs/withConfig/withConfig';
import { USER_TYPE } from 'Constants/users';
import { LQ_SHORTLIST_FEATURE } from 'Constants/items';
export class NavBar extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.shape({
            formatMessage: PropTypes.func.isRequired
        }),
        item: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        onTagTap: PropTypes.func.isRequired,
        selectedTabId: PropTypes.number.isRequired,
        location: PropTypes.object,
        isItemOutdated: PropTypes.bool.isRequired,
        getTrackingInfo: PropTypes.func.isRequired,
        isMyItem: PropTypes.bool.isRequired,
        config: PropTypes.shape({
            get: PropTypes.func
        }),
        featureFlag: PropTypes.string
    }

    static defaultProps = {
        config: {
            get: () => { }
        }
    }

    constructor(props) {
        super(props);

        const translations = {
            overview: props.intl.formatMessage({ id: 'overview' }),
            features: props.intl.formatMessage({ id: 'features' }),
            financing: props.intl.formatMessage({ id: 'cfheadline' }),
            exchange: props.intl.formatMessage({ id: 'exchange' })
        };
        const isCocoUser = props.user?.dealer?.car?.dealer_type === USER_TYPE.COCO;

        this.titles = getTitles(props.item, translations, props.config, isCocoUser);

        const { showFavBtn, showSocialShareBtn } = props.config.get('adpvAuto') || {};

        this.showFavBtn = showFavBtn || this.props.featureFlag === LQ_SHORTLIST_FEATURE;
        this.showSocialShareBtn = showSocialShareBtn;
    }

    handleTabTap = ev => {
        this.props.onTagTap(Number(ev.target.dataset.tabId));
    }

    render() {
        return (
            <ul className={ classNames(css.navBar, css.topPromoBar) }>
                {
                    this.titles.map((title, idx) => {
                        return title ? (<li
                            key={ title }
                            className={ classNames(css.navBarItem, {
                                [css['navBarItem--selected']]: this.props.selectedTabId === idx
                            }) }
                            onClick={ this.handleTabTap }
                            data-tab-id={ idx }
                        >
                            {title.toUpperCase()}
                        </li>) : null;
                    })
                }
                { this.showSocialShareBtn && <li className={ classNames(css.actionButtons, css.alignRight) }>
                    <div className={ css.shareButtonWrapper }>
                        <ShareButton
                            path={ this.props.location.pathname }
                            title={ this.props.item.title }
                            isMyItem={ false }
                            isItemOutdated={ this.props.isItemOutdated }
                            itemId={ this.props.item.id }
                            getTrackingInfo={ this.props.getTrackingInfo }
                            size={ 28 }
                        />
                    </div>
                    <div className={ css.btnTitle }>
                        {this.props.intl.formatMessage({ id: 'shareContact' })}
                    </div>
                </li>}
                {!this.props.isMyItem && this.showFavBtn && <li className={ css.actionButtons }>
                    <FavoriteButton
                        name="Favorite"
                        item={ this.props.item }
                        getTrackingInfo={ this.props.getTrackingInfo }
                        size={ 28 }
                    />
                    <div className={ css.btnTitle }>
                        {this.props.intl.formatMessage({ id: 'wishlist' })}
                    </div>
                </li>}
            </ul>
        );
    }
}

export default compose(
    withConfig,
    injectIntl
)(NavBar);
